//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SectionList.js";
import "../GeometricUtilities/GeometricUtilities.Rebuild.js";
import "../no/Section.js";
import "../GeometricUtilities/GeometricUtilities.Continuity.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
import "../no/ObjectList.js";
let d=[[[0,"BodyPreference",1,0],[0,"Construction",1,0],[1,"CrossCurvesList",0,"SectionList",0],[1,"CrossSurfaceRebuildData",0,"GeometricUtilities.Rebuild",0],[1,"CrossTemplateString",0,"Section",0],[0,"CurvatureTolerance",1,0],[0,"Emphasis",1,0],[1,"FirstCrossContinuity",0,"GeometricUtilities.Continuity",0],[1,"FirstPrimaryContinuity",0,"GeometricUtilities.Continuity",0],[0,"IntersectionTolerance",1,0],[1,"LastCrossContinuity",0,"GeometricUtilities.Continuity",0],[1,"LastPrimaryContinuity",0,"GeometricUtilities.Continuity",0],[0,"PositionTolerance",1,0],[1,"PrimaryCurvesList",0,"SectionList",0],[1,"PrimarySurfaceRebuildData",0,"GeometricUtilities.Rebuild",0],[1,"PrimaryTemplateString",0,"Section",0],[1,"Spine",0,"Section",0],[0,"SplitOutputAlongBoundaryCurves",1,0],[0,"TangentTolerance",1,0]],[],[]];
SPLM.Features.ThroughCurveMeshBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ThroughCurveMeshBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ThroughCurveMeshBuilder.EmphasisType = Object.freeze({
    "Both" : "Both", "Primary" : "Primary", "Cross" : "Cross"});

SPLM.Features.ThroughCurveMeshBuilder.ConstructionMethod = Object.freeze({
    "Normal" : "Normal", "SplinePoints" : "SplinePoints", "Simple" : "Simple"});

SPLM.Features.ThroughCurveMeshBuilder.BodyPreferenceTypes = Object.freeze({
    "Solid" : "Solid", "Sheet" : "Sheet"});

export default SPLM;